module.exports = __webpack_public_path__ + "static/media/drpic3.77b6f030.png";